<template>
  <div class="rule">
    <div class="rule_nav">
      <navbar
        title="认领手机"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <van-row class="box">
      <van-col span="24" class="phone_num">
        认领手机数量<span>x 1</span>
      </van-col>
      <van-col span="24" class="rule_content">
        <div class="title">账号代运营规则：</div>
        <div class="content">
          <p class="con_title"><span></span>项目背景</p>
          <p class="con">
            销巴会员提供一个账号，由具备运营资质的第三方公司负责该账号的运营推广，再由销巴平台自代运营服务生效后的第4个月开始给予销巴会员300元/月的红包补贴，作为销巴会员提供账号的项目收益。
          </p>
          <p class="con_title"><span></span>押金收取</p>
          <p class="con">
            销巴会员开通代运营服务后，可申请认领一台智能手机，并向销巴平台缴纳2000元押金，缴纳的押金不享受积分赠送。如开通其他社交账号需要缴纳服务费的，缴费标准与申退规则以相关平台为准。
          </p>
          <p class="con_title"><span></span>押金退回</p>
          <p>
            销巴平台与会员均拥有单方面终止账号代运营服务的权利。如代运营服务终止，2000元押金原路退回或退回至会员余额。
          </p>
          <p class="con">
            关于认领手机的特别注意事项：在代运营服务终止后，销巴会员需将智能手机寄送至平台指定地址，并确保手机无软硬件损坏。如认领的手机在使用期间存在部分软硬件损坏，则平台退还部分押金（具体退还比例由专属客服与会员沟通协商）；如遗失手机，则平台按当时市场价格扣除保证金。
          </p>
          <p class="con_title"><span></span>签订协议</p>
          <p class="con">
            销巴会员作为代运营账号的持有者，需与销巴平台、第三方公司在销巴生活APP上签订三方电子协议。协议详情，请移步相应页面查看。
          </p>
        </div>
      </van-col>
    </van-row>
    <van-row class="rule_footer">
      <van-col span="24">
        <span class="total">押金合计：<span>￥2000.00</span></span>
        <span class="button">
          <btn
            :btntext="'提交订单'"
            :btnwidth="'10.4rem'"
            :height="'3.6rem'"
            :bgcolor="'#F9591B'"
            :borderradius="'1.8rem'"
            :btncolor="'#fff'"
            :fontsize="'1.6rem'"
            :fontweight="700"
            @btnClick="toSubmit"
          />
        </span>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
    };
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    toSubmit() {
      this.$router.push("/accountAgent/confirm");
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.rule {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .rule_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #f5f6f7;
    z-index: 3;
  }

  .box {
    padding: 10rem 1.2rem 6rem;
    box-sizing: border-box;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .phone_num {
      width: 100%;
      height: 6.2rem;
      line-height: 6.2rem;
      border-radius: 0.6rem;
      background: #fff;
      padding: 0 1.5rem;
      color: #333;
      font-weight: 700;
      font-size: 1.6rem;

      span {
        color: #999;
        font-weight: 500;
        float: right;
      }
    }

    .rule_content {
      height: auto;
      padding: 1.5rem;
      box-sizing: border-box;
      font-size: 1.3rem;
      color: #999;
      border: dashed 1px #d7d7d7;
      margin-top: 1rem;
      border-radius: 0.6rem;

      .title {
        height: 2rem;
        line-height: 2rem;
        font-size: 1.4rem;
        font-weight: 700;
      }

      .content {
        .con_title {
          font-weight: 700;
          height: 2.2rem;
          line-height: 2.2rem;
          margin-top: 1rem;

          span {
            width: 0.4rem;
            height: 0.4rem;
            border-radius: 0.2rem;
            background: rgba(153, 153, 153, 0.8);
            margin-right: 0.5rem;
            display: inline-block;
            float: left;
            margin-top: 0.9rem;
          }
        }

        .con {
          line-height: 2.2rem;
        }
      }

      /deep/img {
        width: 100%;
      }
    }
  }

  .rule_footer {
    // height: 8.3rem;
    // padding: 0.7rem 1.2rem 3.3rem;
    height: 5rem;
    padding: 0.7rem 1.2rem 0;
    background: #fff;
    color: #f9591b;
    text-align: right;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    .total {
      line-height: 3.6rem;
      font-size: 1.4rem;
      span {
        font-size: 1.8rem;
        font-weight: 700;
        margin-right: 1.2rem;
      }
    }
    .button {
      float: right;
    }
  }
}
</style>


